import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "./notification-slider.css"


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const NotificationSliderPure = (props) => {
    const { t } = useTranslation();
    const {
        initializeNotification,
        showNotification,

        toggleNotification,
        playSound,
        toggleSoundActive,
        soundActive,
        onUpdateNotification,

        socket,
        helpSection
    } = props;
    const [scrollY, setScrollY] = useState(60)
    const [notifications, setNotifications] = useState(socket)

    useEffect(() => {
        setNotifications(socket)
        notifications.sort((a, b) => (+b.notificationUser.notificationIsPinged) - (+a.notificationUser.notificationIsPinged))

    }, [socket])

    useEffect(() => {
        notifications.sort((a, b) => (+b.notificationUser.notificationIsPinged) - (+a.notificationUser.notificationIsPinged))

    }, [notifications])

    // const sendPing = () => {
    //     socket.emit('ping');
    // }

    const disableNotification = async (notification) => {
        //Leer o Atender Notificacion
        let notificationStatus
        if (notification.notificationTypeId === 1) {
            notificationStatus = 1
        } else {
            notificationStatus = 3
        }

        let notificationParams =
        {
            "userIds": [notification.notificationUser.userId],
            "notificationStatusId": notificationStatus,
            "notificationIsPinged": notification.notificationUser.notificationIsPinged,
            "title": notification.title,
            "description": notification.description,
            "notificationUrl": notification.notificationUrl,
            "notificationHasMedia": [1],
            "notificationGroupId": notification.notificationGroupId
        }

        let myArray = notifications.filter(function (obj) {
            return obj.id !== notification.id;
        });

        //Borrar del elemento local
        setNotifications(myArray)

        onUpdateNotification(notification.id, notificationParams)
    }

    const handleMenuOne = (url, notificationType) => {
        //Funcion del primer boton en el Dropdown
        RedirectExample(url, notificationType)
    };

    const handleMenuTwo = async (notification) => {
        //Funcion del segundo boton en el Dropdown
        let notificationParams =
        {
            "userIds": [notification.notificationUser.userId],
            "notificationStatusId": notification.notificationTypeId,
            "notificationIsPinged": !notification.notificationUser.notificationIsPinged,
            "title": notification.title,
            "description": notification.description,
            "notificationUrl": notification.notificationUrl,
            "notificationHasMedia": [1],
            "notificationGroupId": notification.notificationGroupId
        }
        let updatedNotification = await onUpdateNotification(notification.id, notificationParams)
        setNotifications(updatedNotification)
    }

    const handleMenuThree = () => {
        //Funcion del tercer boton en el Dropdown
        toggleSoundActive()
    };

    const RedirectExample = (url, notificationType) => {
        if (url === "" || notificationType === process.env.REACT_APP_NOTIFICATION_TYPE_INFO) {
            return null
        } else {
            toggleNotification(false)
            window.location.replace(`#/${url}`);
        }
    }

    function padTo2Digits(num) {
        return String(num).padStart(2, '0');
    }

    //Funcion para modificar el texto de la hora
    const handleDate = (current) => {
        let date
        let halfAnHourAgo = moment().subtract(30, 'minutes').toDate().getTime();
        let oneDayAgo = moment().subtract(1, 'days').toDate().getTime();
        let twoDaysAgo = moment().subtract(2, 'days').toDate().getTime();

        if (current > halfAnHourAgo) {
            date = 'Ahora'
        } else if ((current > oneDayAgo) && (moment(current).isSame(moment(), "day"))) {
            date = `Hoy  ${padTo2Digits(current.getHours())}:${padTo2Digits(current.getMinutes())}`
        } else if (current > twoDaysAgo && (moment(current).isSame(moment().subtract(1, 'days'), "day"))) {
            date = `Ayer  ${padTo2Digits(current.getHours())}:${padTo2Digits(current.getMinutes())}`
        } else {
            date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}   ${padTo2Digits(current.getHours())}:${padTo2Digits(current.getMinutes())}`
        }
        return date
    }

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 60) {
                setScrollY(0)
            } else {
                setScrollY(60)
            }
        });
    }, [window.scrollY])

    const sliderRef = useRef(null);

    function handleClickOutside(event) {
        if (
            showNotification && sliderRef.current &&
            !sliderRef.current.contains(event.target) &&
            !event.target.classList.contains('k-avatar-image') &&
            !event.target.classList.contains('icon-notification')
        ) {
            toggleNotification(false)
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showNotification]);

    return (
        <div ref={sliderRef} className={`${initializeNotification ? "" : "notificationPanel hide"}`}>
            <div style={{ marginTop: scrollY }} className={`notificationPanel ${showNotification ? "open" : ""}`}>
                {/* Header Verde */}
                <div className="notificationPanel-header">
                    <p className="notificationPanel-header-title">
                        {t("notificationSlider.title")}
                    </p>
                </div>

                <div>
                    {notifications && notifications.length ? notifications.map((notification) => {
                        return (
                            <div className="notification-digital-contract">
                                <div className="notification-digital-contract-title">
                                    <div className="notification-title-name">
                                        <img
                                            src={notification.iconUrl}
                                            className="notification-icon"
                                            alt="icono de sección"
                                        />
                                        <span className="notificacion-title-text">{notification.title}</span>
                                    </div>
                                    <div className="notification-title-icons">
                                        <span className="notification-title-icon2" onClick={(e) => disableNotification(notification)}>x</span>
                                        <div className="dropdown">
                                            <Dropdown
                                                trigger={<span className="notification-title-icon1">...</span>}
                                                menu={[
                                                    <button className={`${notification.notificationUrl !== "" ? null : "notification-menu1-none"} `} onClick={(e) => handleMenuOne(notification.notificationUrl, notification.notificationTypeId)}>{t("notificationSlider.menu1")}</button>,
                                                    <button onClick={(e) => handleMenuTwo(notification)}>{notification.notificationUser.notificationIsPinged ? t("notificationSlider.unpin") : t("notificationSlider.pin")}</button>,
                                                    <div onClick={handleMenuThree}><span>{t("notificationSlider.sound")}</span><input type="checkbox" defaultChecked={soundActive} /></div>,
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div onClick={(e) => RedirectExample(notification.notificationUrl, notification.notificationTypeId)} className='notification-description-box'>
                                    <div className="notification-digital-contract-text">
                                        <span>{notification.description}</span>
                                    </div>
                                    <div className="notification-digital-contract-time">
                                        {/* <span>{handleDate(new Date('January 9, 2023 10:01:30'))}</span> */}
                                        <span>{notification.createdDate}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                        : <div className="notificationPanel-no-notifications">
                            <p>{t("notificationSlider.noNotifications")}</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};


//Elemento Dropdown para Notificaciones.
export const Dropdown = ({ trigger, menu }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    return (
        <div className="dropdown">
            {React.cloneElement(trigger, {
                onClick: handleOpen,
            })}
            {open ? (
                <ul className="menu">
                    {menu.map((menuItem, index) => (
                        <li key={index} className="menu-item">
                            {React.cloneElement(menuItem, {
                                onClick: () => {
                                    menuItem.props.onClick();
                                    setOpen(false);
                                },
                            })}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};
export { NotificationSliderPure as default };
